import { api } from '@/api/api';
import { apis } from '@/config';
import { util, wait } from '@/api/util';
import { getIn18Text } from '@/api/utils';
export class MailContactHandler {
    constructor(actions, subActions) {
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.eventApi = api.getEventApi();
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.actions = actions;
        this.subActions = subActions;
    }
    handleContactList(prItems, noContactRace, _account) {
        const contactList = [];
        prItems.forEach(it => {
            it.senderContactMap.parsed.forEach(item => contactList.push(item));
            it.receiverContactMap.parsed.forEach(item => contactList.push(item));
        });
        return this.handleContactRawList(contactList, noContactRace, _account).then((contactMap) => {
            prItems.forEach(it => {
                this.handleContactItem(it, contactMap);
            });
            return prItems;
        });
    }
    addContact(params, _account) {
        const insertParams = params.map(param => ({
            name: (param === null || param === void 0 ? void 0 : param.originName) || (param === null || param === void 0 ? void 0 : param.contact.contact.contactName) || (param === null || param === void 0 ? void 0 : param.contact.contact.accountName),
            comment: getIn18Text('XIEXINZIDONGTIANJIALIAN'),
            emailList: [param.contactItem.contactItemVal],
            auto: 1,
            groupIdList: [],
            _account,
        }));
        this.contactApi
            .doInsertContact({
            list: insertParams,
            _account,
        })
            .then(r => {
            if (r.success) {
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        popupType: 'toast',
                        popupLevel: 'info',
                        title: getIn18Text('TIANJIALIANXIRENCHENGGONGv16'),
                        code: 'SOK',
                    },
                    eventSeq: 0,
                });
            }
        });
    }
    handleContactItem(it, contactMap) {
        it.senderContactMap.parsed.forEach(item => {
            const element = contactMap[item.email + item.type];
            it.sender.push({
                mailMemberType: item.type,
                contactItem: element.contactItem,
                contact: element.contact,
                originName: item.name,
                inContactBook: element.inContactBook,
            });
        });
        it.receiverContactMap.parsed.forEach(item => {
            const element = contactMap[item.email + item.type];
            it.receiver.push({
                mailMemberType: item.type,
                contactItem: element.contactItem,
                contact: element.contact,
                originName: item.name,
                inContactBook: element.inContactBook,
            });
        });
    }
    getContractItemByEmail(id, type, _accont) {
        if (!id || id.length === 0) {
            return Promise.reject(new Error('需要提供email数组参数'));
        }
        const contactList = id.map(it => ({
            item: it,
            email: it,
            name: undefined,
            type,
        }));
        return this.handleContactRawList(contactList, undefined, _accont).then(res => {
            const ret = [];
            for (const idx in contactList) {
                const it = contactList[idx];
                const re = res[it.email + it.type];
                if (re && re.contactItem.contactItemVal && re.contactItem.contactItemVal.length > 0) {
                    ret.push(Object.assign(Object.assign({}, re), { mailMemberType: it.type, inContactBook: true }));
                }
            }
            return ret;
        });
    }
    buildRawContactItem(item, _account) {
        if (!item) {
            const currentUser = this.systemApi.getCurrentUser(_account);
            if (currentUser) {
                if (currentUser.contact) {
                    const citme = currentUser.contact.contactInfo.filter(it => it.contactItemType === 'EMAIL').pop() || {
                        type: '',
                        contactId: currentUser.id,
                        contactItemRefer: '',
                        contactItemType: 'EMAIL',
                        contactItemVal: currentUser.id,
                        createTime: 0,
                        id: '',
                        isDefault: 1,
                        unreadItemCount: 0,
                        updateTime: 0,
                        useFrequency: 0,
                    };
                    return {
                        contact: currentUser.contact,
                        contactItem: citme,
                        inContactBook: true,
                    };
                }
                if (currentUser.id) {
                    item = {
                        item: '',
                        name: currentUser.nickName,
                        email: currentUser.id,
                        type: '',
                        avatar: '',
                    };
                }
            }
        }
        if (!item) {
            throw new Error('参数错误，未传入item');
        }
        const properties = this.systemApi.handleAccountAndDomain(item.email);
        const contactName = item.name || properties.account || 'unknown';
        const contactPYName = this.toPinyin(contactName);
        const contactLabel = util.getContactLabel(contactPYName);
        const contactPYLabelName = util.getContactPYLabel(contactName);
        const _lastUpdateTime = Date.now();
        const cItem = {
            type: 'external',
            contactId: item.email,
            contactItemRefer: '',
            contactItemType: 'EMAIL',
            contactItemVal: item.email,
            createTime: 0,
            id: '',
            emailType: -1,
            isDefault: 0,
            unreadItemCount: 0,
            updateTime: 0,
            useFrequency: 0,
            _lastUpdateTime,
        };
        const contactItem = {
            inContactBook: false,
            contact: {
                contact: {
                    avatar: item === null || item === void 0 ? void 0 : item.avatar,
                    contactName,
                    contactPYName,
                    contactLabel,
                    contactPYLabelName,
                    accountStatus: -1,
                    accountVisible: 0,
                    id: item.id || '',
                    accountId: item.email,
                    accountName: item.email,
                    type: 'external',
                    color: this.contactApi.getColor(item.email),
                    visibleCode: 0,
                    enableIM: false,
                },
                contactInfo: [cItem],
            },
            contactItem: cItem,
            mailMemberType: item.type,
            originName: item.name,
        };
        return contactItem;
    }
    transContactModel2MailContactModel(item, receiverType) {
        const cItem = item.contactInfo.find(info => info.contactItemType === 'EMAIL' && info.isDefault === 1);
        const _lastUpdateTime = Date.now();
        const contactInfo = {
            id: '',
            contactId: item.contact.id,
            contactItemType: 'EMAIL',
            contactItemVal: item.contact.displayEmail || item.contact.accountName,
            contactItemRefer: '',
            type: item.contact.type,
            isDefault: 1,
            _lastUpdateTime,
        };
        return {
            contact: item,
            mailMemberType: receiverType,
            contactItem: cItem || contactInfo,
            inContactBook: item.contact.type !== 'external',
        };
    }
    parseEmailAddress(add) {
        const f = '(\\S+@([\\w\\-\\_]+\\.)+[\\w\\-]{1,15})';
        let reg;
        if (/[<>]/.test(add)) {
            if (/"/.test(add)) {
                reg = new RegExp('^"(.*)"\\s*<' + f + '>$');
            }
            else {
                reg = new RegExp('^(.*)<' + f + '>$');
            }
        }
        else {
            reg = new RegExp('^(^)' + f + '$');
        }
        return reg.exec(add);
    }
    handleEmailListStringToParsedContent(listStr, ret) {
        if (!listStr || listStr.length === 0) {
            return ret;
        }
        const contactPattern = [
            {
                reg: /,?\s*"\s*(?:[+\-])?\s*([^"]+)"\s*<\s*([\w\-._*]+@[\w\.\-]+\.[a-zA-Z]{2,25})\s*>\s*/gi,
                nameIndex: 1,
                emailIndex: 2,
                total: 2,
            },
            {
                reg: /(?:[,+\-])?\s*([^<> \t"](?:[^<>"]+)?)\s*<\s*([\w\-._*]+@[\w\.\-]+\.[a-zA-Z]{2,25})\s*>\s*/gi,
                nameIndex: 1,
                emailIndex: 2,
                total: 2,
            },
            {
                reg: /^"([^"']*)"\s*<(\S+@([\w\-\_]+\.)+[\w\-]{1,15})>$/gi,
                nameIndex: 1,
                emailIndex: 2,
                total: 2,
            },
            {
                reg: /,?\s*[+-]?\s*(([\w\-._#*&!$%'+/=?^`{|}~]+)@[\w.\-_]+\.[a-zA-Z]{2,25})\s*/gi,
                nameIndex: 2,
                emailIndex: 1,
                total: 2,
            },
        ];
        let item = null;
        const set = new Set();
        const pos = new Map();
        let allUnmatched = true;
        for (const conf of contactPattern) {
            let start = 0;
            while (start < listStr.length) {
                conf.reg.lastIndex = this.getNextStart(start, pos);
                let hasMatch = false;
                item = conf.reg.exec(listStr);
                if ((item === null || item === void 0 ? void 0 : item.length) && item.length >= conf.total && !set.has(item[conf.emailIndex])) {
                    const emailEl = item[conf.emailIndex];
                    ret.parsed.push({
                        item: item[0],
                        name: item[conf.nameIndex],
                        email: emailEl,
                        type: ret.type || '',
                    });
                    const end = conf.reg.lastIndex + 1;
                    pos.set(end - item[0].length - 1, end);
                    start = end;
                    hasMatch = true;
                    allUnmatched = false;
                    set.add(emailEl);
                }
                if (!hasMatch) {
                    break;
                }
            }
        }
        if (allUnmatched) {
            ret.parsed.push({
                item: listStr,
                name: listStr,
                email: listStr,
                type: ret.type || '',
                isIllegalEmail: true,
            });
        }
        return ret;
    }
    getNextStart(st, pos) {
        let start = st;
        while (pos.has(start) && pos.get(start)) {
            start = pos.get(start) || 0;
        }
        return start;
    }
    parseContactStr(listStr, type) {
        const items = typeof listStr === 'string' ? [listStr] : listStr;
        const ret = {
            origin: items,
            parsed: [],
            type,
        };
        if (!listStr || listStr.length === 0) {
            if (ret.parsed.length === 0) {
                let item = '';
                if (item) {
                    item = Array.isArray(items) ? items.join(',') : String(items);
                }
                ret.parsed.push({
                    item,
                    email: '',
                    name: type === '' ? '无发件人' : '无收件人',
                    type,
                });
            }
            return ret;
        }
        for (const item of items) {
            if (item && item.length > 0) {
                this.handleEmailListStringToParsedContent(item, ret);
            }
        }
        return ret;
    }
    concatProcessingEntry(a, b, distinct) {
        const map = {};
        if (distinct && a.parsed) {
            a.parsed.forEach(it => {
                map[it.email + ':' + it.type] = it;
            });
        }
        a.origin && b.origin && a.origin.push(...b.origin);
        !a.origin && b.origin && (a.origin = b.origin);
        a.parsed &&
            b.parsed &&
            b.parsed.forEach(it => {
                if (!distinct) {
                    a.parsed.push(it);
                }
                else if (!map[it.email + ':' + it.type]) {
                    a.parsed.push(it);
                }
            });
        !a.parsed && b.parsed && (a.parsed = b.parsed);
        a.result &&
            b.result &&
            b.result.forEach(item => {
                var _a;
                (_a = a.result) === null || _a === void 0 ? void 0 : _a.push(item);
            });
        !a.result && b.result && (a.result = b.result);
        return a;
    }
    mapMailEntryToProcessingItem(item, id) {
        const dist = {
            receiverContactMap: this.parseContactStr(item.to, 'to'),
            senderContactMap: this.parseContactStr(item.from, ''),
            sender: [],
            receiver: [],
        };
        if (item.cc && item.cc.length > 0) {
            this.concatProcessingEntry(dist.receiverContactMap, this.parseContactStr(item.cc, 'cc'), true);
        }
        if (item.bcc && item.bcc.length > 0) {
            this.concatProcessingEntry(dist.receiverContactMap, this.parseContactStr(item.bcc, 'bcc'), true);
        }
        return Object.assign(Object.assign(Object.assign({}, item), dist), { id });
    }
    handleContactRawList(contactList, noContactRace, _account) {
        return this.getContactItemWithTimeout(contactList, noContactRace, _account)
            .then((res) => {
            var _a;
            const allMail = new Set();
            contactList.forEach(it => {
                if (it.email) {
                    allMail.add(it.email.toLocaleLowerCase());
                }
            });
            const contactMap = {};
            if (res && res.length > 0) {
                for (const item of res) {
                    if (!item) {
                        console.error('[mail_obtain_contact_helper] handleContactRawList error', res);
                    }
                    (_a = item === null || item === void 0 ? void 0 : item.contactInfo) === null || _a === void 0 ? void 0 : _a.forEach(contactItem => {
                        if (contactItem && contactItem.contactItemType === 'EMAIL' && allMail.has(contactItem.contactItemVal)) {
                            const email = contactItem.contactItemVal;
                            const contactNew = Object.assign(Object.assign({}, item.contact), { hitQueryEmail: email });
                            const storedContact = contactMap[email];
                            if (!storedContact || storedContact.contact.contact.type === 'personal') {
                                contactMap[email] = {
                                    mailMemberType: '',
                                    contactItem,
                                    contact: {
                                        contact: contactNew,
                                        contactInfo: item.contactInfo,
                                        orgs: item.orgs,
                                        customerOrgModel: item.customerOrgModel,
                                    },
                                    inContactBook: true,
                                };
                            }
                        }
                    });
                }
            }
            const newContactMap = {};
            contactList.forEach(it => {
                var _a;
                const email = (_a = it.email) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
                const element = contactMap[email];
                if (!element) {
                    newContactMap[it.email + it.type] = this.buildRawContactItem(it);
                }
                else {
                    const newElement = Object.assign({ originName: it.name }, element);
                    newContactMap[it.email + it.type] = newElement;
                }
            });
            return newContactMap;
        })
            .catch(err => {
            console.warn('mail contact obtain error:', err);
            const contactMap = {};
            contactList.forEach(it => {
                const element = contactMap[it.email];
                if (!element) {
                    contactMap[it.email + it.type] = this.buildRawContactItem(it);
                }
                else {
                }
            });
            return contactMap;
        });
    }
    getContactItemWithTimeout(list, noRace = false, _account) {
        console.log('[getContactItemWithTimeout] list', noRace, _account);
        return Promise.resolve(this.buildRawContactItems(list, 0));
    }
    async buildRawContactItems(list, timeout = 4000) {
        const models = list.map(it => { var _a; return (_a = this.buildRawContactItem(it)) === null || _a === void 0 ? void 0 : _a.contact; });
        if (timeout === 0) {
            return Promise.resolve(models);
        }
        return wait(4000).then(() => {
            console.warn('[buildRawContactItems] race', models);
            return Promise.resolve(models);
        });
    }
    toPinyin(str) {
        return util.toPinyin(str);
    }
    buildEmptyContact(b) {
        if (b) {
            return [
                this.buildRawContactItem({
                    type: 'to',
                    name: '无收件人',
                    email: '',
                }),
            ];
        }
        return [
            this.buildRawContactItem({
                type: '',
                name: '无发件人',
                email: '',
            }),
        ];
    }
}
MailContactHandler.contactPattern = {
    withName: /\s*(?:([^<> \t"]+)|"([^"]+)")\s*<([\w\-._*]+@[\w.-]+\.[a-zA-Z]{2,20})>/i,
    withoutName: /\s*(([\w\-._#*]+)@[\w.\-_]+\.[a-zA-Z]{2,20})/i,
};
